var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isbor?'borderBottom':'',attrs:{"id":"Location"}},[_vm._v("\n      您的位置:\n       "),_vm._l((_vm.locationList),function(val,index){return _c('span',{key:index,on:{"click":function($event){return _vm.routerBack(val.toPath)}}},[_vm._v(_vm._s(val.name)+" "),_c('span',{staticClass:"location_logo"})])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b760a9b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Location.vue
// module id = null
// module chunks = 